import React from 'react';
import { MDBIcon, MDBToast } from 'mdb-react-ui-kit';

const Toast = ({ toast, resetToast, autoHide = true, hasHeader }) => {
  let icon;
  if (toast.type === 'success') {
    icon = <MDBIcon far icon="check-circle" size='lg' />;
  } else if (toast.type === 'danger') {
    icon = <MDBIcon far icon="times-circle" size='lg' />;
  }

  const bodyContent = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {toast.message}
      {icon}
    </div>
  );
  return (
    <MDBToast
      color={toast.type}
      open={toast.isOpen}
      onClose={() => resetToast()}
      autohide={autoHide}
      position={toast.position}
      delay={5000}
      appendToBody
      headerContent={
        hasHeader ?
          <>
            <strong className='me-auto'>You have a new notification</strong>
          </>
          :
          ''
      }
      bodyContent={bodyContent}
    />
  );
};

export default Toast;
